import { useParams } from 'react-router-dom'
import ModalDeleteFilled from '../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { ModalEditComponentProps } from '../../../../../../baseComponents/ModalsLayouts/types'
import { useFetchText } from '../../../../../../utils/hooks/useFetchText'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { OnSubmit } from '../../../../../../forms/TwinForm/types'
import { useCallback } from 'react'

interface ModalDeleteProductAddonProps extends ModalEditComponentProps {
    url: string
 }

const ModalDeleteProductAddon: React.FC<ModalDeleteProductAddonProps> = ({ url, setOpened, allRowData, onSubmit, basicData }) => {
    const { t } = useTwinTranslation()
    const params = useParams<{ id: string }>()
    const id = params.id
    const { myOnSubmit } = useModalDeleteProductAddonLogic({ onSubmit, getData: basicData?.getData })
    const { handleFetchText } = useFetchText({
        onSubmit: myOnSubmit,
        url,
        data: {
            ProductAddonId: allRowData?.ProductAddonId,
            ProductId: id
        }
    })
    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureDeleteProductAddon', '¿Seguro quieres eliminar este complemento del producto?'),
            subtitle: t('onceDeletedNotRecoverM', 'Una vez eliminado no podrás recuperarlo')
        }} />
    )
}

interface ModalDeleteProductAddonLogicProps {
    onSubmit: OnSubmit
    getData?: ()=>Promise<void>
}

const useModalDeleteProductAddonLogic = ({onSubmit, getData}: ModalDeleteProductAddonLogicProps) => {

    const myOnSubmit: OnSubmit = useCallback((res, values) => {
        onSubmit(res, values)
        getData?.()
    }, [onSubmit, getData])

    return { myOnSubmit }
}

interface ModalDeleteProductAddonBaseProps extends ModalEditComponentProps {}

export const ModalDeleteProductAddonSell: React.FC<ModalDeleteProductAddonBaseProps> = ({...rest}) => {
    return (<ModalDeleteProductAddon url='/api/app/product/productAddon/deleteProductAddon' {...rest} />)
}
export const ModalDeleteProductAddonBuy: React.FC<ModalDeleteProductAddonBaseProps> = ({...rest}) => {
    return (<ModalDeleteProductAddon url='/api/app/product/productAddonBuy/deleteProductAddonBuy' {...rest} />)
}